export const AUTH_CONSTANTS = {
    JOIN_OUR:'Join Our',
    PASSWORD_REQUIRED:'Password is required',
    REQUIRED:'required',
    PATTERN:'pattern',
    PASSWORD_REQUIREMENTS:`Your password didn't meet complexity requirements`,
    CHANGE_LANGUAGE:'Change Language',
    SIGN_IN:'Sign In',
    SELECT_BUSSINESS_TYPE:'Select business type.',
    FIRST_NAME_REQUIRED:'First name is required',
    LAST_NAME_REQUIRED:'Last name is required',
    BUSINESS_NAME_REQUIRED:'Business name is required',
    PASSWORD_PATTERN_SIGNUP:'Password must be alphanumeric and at least 8 characters',
    EMAIL_REQUIRED: 'Email is required',
    EMAIL_INVALID: 'Please enter a valid email address',
    SOMETHING_WENT_WRONG:'Something went wrong'
};